import React from 'react'
import classes from './adButton.module.css'
import microsoftLogo from '../../images/microsoft_PNG18.png'

export default function (props) {
  return (
    <button className={classes.button} type='button' onClick={props.onClick}>
      <img src={microsoftLogo} width='20' style={{ marginRight: '12px' }} />
      <span>Sign in with Microsoft</span>
    </button>
  )
}
